import React from 'react';

import InputCost from '../../widgets/input-cost';

import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';
import {cmsColors} from "../../../../../../../common/edlio-js/constants";

export default class OtherMultiChoicePayOption extends React.Component {
	constructor(props) {
		super(props);
		let localization = new Localization(window.edlio.localizations);

		this.state = {
			minCost: this.props.data.label[0],
			maxCost: this.props.data.label[1] != "0.00" ? this.props.data.label[1] : localization.localize("any")
		}
	}

	onMinChange (newMin) {
		var isRequired = document.getElementById(this.props.parentId + "_required_checkbox").checked;

		if (isRequired && newMin < 1.00) {
			newMin = parseFloat("1.00").toFixed(2);
		}

		this.setState({
			minCost: newMin
		}, () => {
			if(
				Number(newMin) > Number(this.state.maxCost)
				&&
				newMin
				&&
				this.state.maxCost
			) {
				this.setState({
					minCost: this.state.maxCost
				}, () => {
					alert("Min value must be less than max value.");
				});
			}
		});
	}

	onMaxChange (newMax) {
		this.setState({
			maxCost: newMax
		}, () => {
			if(
				Number(newMax) < Number(this.state.minCost)
				&&
				newMax
				&&
				this.state.minCost
			) {
				this.setState({
					maxCost: this.state.minCost
				}, () => {
					alert("Max value must be greater than min value.");
				});
			}
		});
	}

	render() {
		let localization = new Localization(window.edlio.localizations);

		return (
			<div className='multi-choice-pay-option radio input'>
				<SVGIcon name='filled-circle' />
				<span className='other-option' style={{ color: cmsColors.darkGrey2 }}>{localization.localize('Other')}</span>
				<div className="placeholder">
					<span>{localization.localize('$')}</span>
					<span>{localization.localize('Amount')}</span>
				</div>
				<span className="helper-txt">{localization.localize('from min')}</span>
				<InputCost
					ref='minCost'
					cost={this.state.minCost}
					onMinChange={this.onMinChange.bind(this)}
				/>
				<span className="helper-txt">{localization.localize('to max')}</span>
				<InputCost
					ref='maxCost'
					cost={this.state.maxCost}
					onMaxChange={this.onMaxChange.bind(this)}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/other-multi-choice-pay-option.js